import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import EditIcon from "@material-ui/icons/Edit";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Button from "common/components/CustomButtons/Button.jsx";

// core components
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const importedStyle = dashboardStyle;
const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: { ...importedStyle.cardTitle, margin: "30px", padding: "20px" },
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
  ...regularFormsStyle,
  termsText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "justify",
    border: "2px solid black",
    padding: "15px",
  },
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  inputAdornment: {
    position: "relative",
  },
  errorMessage: {
    color: "red",
  },
  label: {
    color: "black",
  },
  contactInfo: {
    margin: "20px",
  },
  checkboxAndRadio: {
    margin: "20px",
  },
  buttonStyle: {
    margin: "20px",
  },
};
//import Contrac from "./AutoPaymentSummary.jsx";
/*

<Button
  color="primaryRed"
  className={classes.marginRight}
  target="_blank"
  href={
    config.API.ADDRESS +
    `?target=user.${ids.user}/contractpdf&x-omicron=${jrr}`
  }
>
  Download
</Button>

*/
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
function daysuffix(day) {
  if (day === 1) {
    return "st";
  }
  if (day === 2) {
    return "nd";
  }
  if (day === 3) {
    return "rd";
  }
  return "th";
}

const Signature = (props) => {
  const ids = useSelector((state) => state.services.ids);
  // const [showmessage] = useState(false);
  const date = new Date();
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const [padHeight, setPadHeight] = useState(window.innerHeight / 4);
  const [padWidth, setPadWidth] = useState(window.innerWidth / 4);
  const { mainPanelRef } = props;

  useEffect(() => {
    function handleResizeEvent() {
      setPadHeight(window.innerHeight / 4);
      setPadWidth(window.innerWidth / 4);
    }
    window.addEventListener("resize", handleResizeEvent);
    if (mainPanelRef != null) {
      mainPanelRef.scrollTop = 0;
    }
    return () => {
      window.removeEventListener("resize", handleResizeEvent);
    };
  }, [mainPanelRef]);

  // function handleFreeTermClick() {
  //   props.setTerm(1);
  // }

  // function handleMonthTermClick() {
  //   props.setTerm(2);
  // }

  const { classes } = props;
  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={10}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <EditIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Review {props.agreementDescription}
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer align="center">
              {" "}
              <GridItem xs={12}>
                <div className={classes.contactInfo}>
                  <h5>
                    <font color="red">
                      Please review your information and signature and
                      <strong> submit the agreement at the bottom</strong>
                    </font>
                  </h5>
                </div>
              </GridItem>
              <GridItem xs={12}>
                <h5>
                  <strong>
                    I have read, understood and agree to{" "}
                    {props.agreementDescription}
                  </strong>
                </h5>
                <br />
              </GridItem>
              <GridItem xs={12}>
                <img
                  alt="Signature Pad"
                  height={padHeight}
                  width={padWidth}
                  src={`${props.signature}`}
                />
              </GridItem>
              <GridItem xs={12}>
                <h5>
                  <strong>______________________</strong>
                </h5>
                <br />
              </GridItem>
              <GridItem xs={12}>
                <div className={classes.contactInfo}>
                  {props.type === "c" ? (
                    <>
                      <h5>Company Name: {props.name}</h5>
                      <h5>Authorized Signer: {props.name2}</h5>
                    </>
                  ) : (
                    <h5>Name: {props.name}</h5>
                  )}
                  <h5>Date: {`${month} ${day}${daysuffix(day)}, ${year}`}</h5>
                  <h5>Customer Number: {ids.user}</h5>
                  <h5>Eletronic signed from identity: {ids.email}</h5>
                  <h5>IP address: {props.ip}</h5>
                </div>
              </GridItem>
              <GridItem xs={12}>
                <Button
                  className={classes.buttonStyle}
                  color="default"
                  onClick={props.goToSignaturePad}
                >
                  Go back
                </Button>
                <Button
                  className={classes.buttonStyle}
                  color="primary"
                  onClick={props.submitContract}
                >
                  Submit
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(Signature);
